// Ana sayfa "Personel Performansı - Haftalık Görevler" yığılmış çubuk grafiği rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'dashboard.weeklyPersonnelPerformance';

export const weeklyPersonnelPerformanceGuide = (t: TFunction): GuideContent => ({
  layout: 'chart',
  title: t(`${G}.title`, 'Personel Performansı - Haftalık Görevler nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu grafik, personelin haftalık görevlerdeki performansını gösterir. Her yatay çubuk bir personeldir ve personelin tamamladığı, devam eden ve kaçırdığı görev sayısından oluşur. En çok görevi olan ilk 5 personel, toplam görev sayısına göre çoktan aza sıralanır. Çubuk parçalarının içindeki sayılar görev adedidir; çubuğun üzerine gelince üç sayıyı birlikte görürsünüz.'),
  chart: {
    kind: 'stacked',
    legend: [
      { color: '#4CAF50', label: t(`${G}.l1.label`, 'Tamamlanan'), text: t(`${G}.l1.text`, 'Personelin başarıyla tamamladığı haftalık görevlerin sayısı. Her tamamlanma kaydı ayrı sayılır.') },
      { color: '#1976D2', label: t(`${G}.l2.label`, 'Devam Eden'), text: t(`${G}.l2.text`, 'Personelin kabul ettiği ve şu an üzerinde çalıştığı etkin haftalık görevlerin sayısı.') },
      { color: '#F44336', label: t(`${G}.l3.label`, 'Kaçırılan'), text: t(`${G}.l3.text`, 'Personelin zamanında tamamlayamadığı haftalık görevlerin sayısı.') },
    ],
    note: t(`${G}.note`, 'Hiç görevi olmayan personel grafikte görünmez.'),
  },
});
